<div
  class="achievement"
  [ngClass]="{
    'rounded-circle':
      achievement.type === 'badge-total' || achievement.type === 'badge-goals',
    'achievement-primary': achievement.type === 'week-streak'
  }"
>
  <div class="achievement-bg">
    <!--span class="icon-wrap">
      <img
        *ngIf="achievement.area == 'prepWell'"
        src="/assets/img/device-prepwell.svg"
        alt="The Prepwell logo"
        class="prepwell-device"
      />
      <fa-icon
        *ngIf="achievement.area == 'prepSteps'"
        [icon]="['fas', 'walking']"
        [fixedWidth]="true"
      ></fa-icon>
      <fa-icon
        *ngIf="achievement.area == 'prepFit'"
        [icon]="['fas', 'running']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'prepStrong'"
        [icon]="$any(['fac', 'lunge'])"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'breatheWell'"
        [icon]="['fas', 'lungs']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'eatWell'"
        [icon]="['fas', 'cutlery']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'drinkGuide'"
        [icon]="['fas', 'martini-glass']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'iQuit'"
        [icon]="['far', 'smoking-ban']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'sleepWell'"
        [icon]="['fas', 'face-sleeping']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'feelWell'"
        [icon]="['fas', 'face-smile-relaxed']"
        [fixedWidth]="true"
      ></fa-icon>
    </span-->
  </div>

  <div class="achievement-content" *ngIf="achievement.type === 'week-streak'">
    <div class="achievement-row">
      <div class="achievement-icon">
        
        <img
        *ngIf="achievement.area == 'prepWell'"
        src="/assets/img/device-prepwell-dark.svg"
        alt="The Prepwell logo"
        class="prepwell-device"
        width="100%"
      />
      <fa-icon
        *ngIf="achievement.area == 'prepSteps'"
        [icon]="['fas', 'walking']"
        [fixedWidth]="true"
      ></fa-icon>
      <fa-icon
        *ngIf="achievement.area == 'prepFit'"
        [icon]="['fas', 'running']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'prepStrong'"
        [icon]="$any(['fac', 'lunge'])"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'breatheWell'"
        [icon]="['fas', 'lungs']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'eatWell'"
        [icon]="['fas', 'cutlery']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'drinkGuide'"
        [icon]="['fas', 'martini-glass']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'iQuit'"
        [icon]="['far', 'smoking-ban']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'sleepWell'"
        [icon]="['fas', 'face-sleeping']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'feelWell'"
        [icon]="['fas', 'face-smile-relaxed']"
        [fixedWidth]="true"
      ></fa-icon>
      </div>
      <div class="achievement-value">
        {{ "" + achievement.total | translate }}
      </div>
    </div>
    <div>
      <div class="achievement-label">
        <span>{{ "WEEK STREAK" | translate }}</span>
      </div>
    </div>
  </div>

  <div class="achievement-content" *ngIf="achievement.type !== 'week-streak'">
    <div *ngIf="achievement.type === 'badge-streak'">
      <div class="achievement-row">
        <div class="achievement-icon">
          <img
            *ngIf="achievement.area == 'prepWell'"
            src="/assets/img/device-prepwell-light.svg"
            alt="The Prepwell logo"
            class="prepwell-device"
          />
          <fa-icon
            *ngIf="achievement.area == 'prepSteps'"
            [icon]="['fas', 'walking']"
            [fixedWidth]="true"
          ></fa-icon>
          <fa-icon
            *ngIf="achievement.area == 'prepFit'"
            [icon]="['fas', 'running']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'prepStrong'"
            [icon]="$any(['fac', 'lunge'])"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'breatheWell'"
            [icon]="['fas', 'lungs']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'eatWell'"
            [icon]="['fas', 'cutlery']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'drinkGuide'"
            [icon]="['fas', 'martini-glass']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'iQuit'"
            [icon]="['far', 'smoking-ban']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'sleepWell'"
            [icon]="['fas', 'face-sleeping']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'feelWell'"
            [icon]="['fas', 'face-smile-relaxed']"
            [fixedWidth]="true"
          ></fa-icon>
        </div>
        <div class="achievement-value">
          {{ "" + achievement.total | translate }}
        </div>
      </div>
      <div>
        <div class="achievement-label">
          <span *ngIf="achievement.type === 'badge-streak'">{{
            (achievement.unit | uppercase) + " STREAK" | translate
          }}</span>
        </div>
      </div>
    </div>
    <div *ngIf="achievement.type === 'badge-total'">
      <div class="achievement-value">
        {{ "" + achievement.total | translate }}
      </div>
      <div class="achievement-label">
        <span
          *ngIf="
            achievement.type === 'badge-total' &&
            (achievement.area == 'prepFit' ||
              achievement.area == 'prepStrong' ||
              achievement.area == 'breatheWell' ||
              achievement.area == 'prepSteps')
          "
        >
          Workouts
        </span>
        <span
          *ngIf="
            achievement.type === 'badge-total' &&
            (achievement.area == 'eatWell' ||
              achievement.area == 'drinkGuide' ||
              achievement.area == 'feelWell' ||
              achievement.area == 'sleepWell' ||
              achievement.area == 'iQuit')
          "
        >
          Entries
        </span>
      </div>
      <div class="achievement-icon">
        
        <img
        *ngIf="achievement.area == 'prepWell'"
        src="/assets/img/device-prepwell-light.svg"
        alt="The Prepwell logo"
        class="prepwell-device"
      />
      <fa-icon
        *ngIf="achievement.area == 'prepSteps'"
        [icon]="['fas', 'walking']"
        [fixedWidth]="true"
      ></fa-icon>
      <fa-icon
        *ngIf="achievement.area == 'prepFit'"
        [icon]="['fas', 'running']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'prepStrong'"
        [icon]="$any(['fac', 'lunge'])"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'breatheWell'"
        [icon]="['fas', 'lungs']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'eatWell'"
        [icon]="['fas', 'cutlery']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'drinkGuide'"
        [icon]="['fas', 'martini-glass']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'iQuit'"
        [icon]="['far', 'smoking-ban']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'sleepWell'"
        [icon]="['fas', 'face-sleeping']"
        [fixedWidth]="true"
      ></fa-icon>

      <fa-icon
        *ngIf="achievement.area == 'feelWell'"
        [icon]="['fas', 'face-smile-relaxed']"
        [fixedWidth]="true"
      ></fa-icon>
      </div>
      <div></div>
    </div>
    <div *ngIf="achievement.type === 'badge-goals'">
      <div class="achievement-row">
        <div class="achievement-icon">
          
          <img
            *ngIf="achievement.area == 'prepWell'"
            src="/assets/img/device-prepwell-light.svg"
            alt="The Prepwell logo"
            class="prepwell-device"
          />
          <fa-icon
            *ngIf="achievement.area == 'prepSteps'"
            [icon]="['fas', 'walking']"
            [fixedWidth]="true"
          ></fa-icon>
          <fa-icon
            *ngIf="achievement.area == 'prepFit'"
            [icon]="['fas', 'running']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'prepStrong'"
            [icon]="$any(['fac', 'lunge'])"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'breatheWell'"
            [icon]="['fas', 'lungs']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'eatWell'"
            [icon]="['fas', 'cutlery']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'drinkGuide'"
            [icon]="['fas', 'martini-glass']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'iQuit'"
            [icon]="['far', 'smoking-ban']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'sleepWell'"
            [icon]="['fas', 'face-sleeping']"
            [fixedWidth]="true"
          ></fa-icon>

          <fa-icon
            *ngIf="achievement.area == 'feelWell'"
            [icon]="['fas', 'face-smile-relaxed']"
            [fixedWidth]="true"
          ></fa-icon>
        </div>
        <div class="achievement-value">
          {{ "" + achievement.total | translate }}
        </div>
      </div>
      <div>
        <div class="achievement-label">
          <span>{{ "GOALS" | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
